import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    width: '16.75rem',
    minHeight: '3.75rem',
    height: 'auto',
    display: 'flex',
    padding: '1.063rem 0 0.75rem 1.782rem',
    borderRadius: '0.625rem',
    boxShadow: '0 0 0.5rem 0 rgba(125, 134, 169, 0.2)',
    backgroundColor: theme.palette.font.white,
    margin: '0 0 0.625rem',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.312rem',
      height: '100%',
      backgroundColor: props.color,
      zIndex: '99',
    },
  }),
  name: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    lineHeight: '1.625rem',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
}));

export default function WardStaff({ item }) {
  const classes = useStyles({ color: item.color });

  return (
    <div className={classes.root}>
      <div className={classes.name}>{item.text}</div>
    </div>
  );
}
